/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-20 14:25:03
 */
import React, { useState, useEffect, useCallback } from 'react'
import { Button, Select } from 'antd'
import { UnorderedListOutlined } from '@ant-design/icons'
import sensors from '../../../utils/sensors'
import { getBaseColumnsData } from '../lib/columnConfigs'

const { Option } = Select

interface IColumnsSettingProps {
  checkedBaseColumns: string[]
  onChange: (baseColumns: string[]) => void
  handleSensorClickItem: (clickItem: string) => void
  isOpenNeteaseShelfReview?: boolean
}

const ColumnsSetting: React.FC<IColumnsSettingProps> = (props) => {
  const { checkedBaseColumns, onChange } = props
  const [open, setOpen] = useState(false)
  const [columns, setColumns] = useState<string[]>([])

  useEffect(() => {
    setColumns([...checkedBaseColumns])
  }, [checkedBaseColumns])

  const handleCancel = () => {
    setOpen(false)
    setColumns([...checkedBaseColumns])
  }
  const handleOK = useCallback(() => {
    sensors.track('web_ai_security_header_setting', { usedHeader: columns })
    setOpen(false)
    const baseColumnsDataIndex = getBaseColumnsData().map(
      (data) => data.dataIndex
    )
    const checkedBaseColumns = columns.filter((column) =>
      baseColumnsDataIndex.includes(column)
    )

    onChange(checkedBaseColumns)
  }, [columns])

  return (
    <div className="columns-setting" style={{ alignItems: 'flex-start' }}>
      <div className="button-list">
        <Button
          icon={<UnorderedListOutlined />}
          type="primary"
          ghost
          onClick={() => {
            setOpen(true)
            props.handleSensorClickItem('listSetting')
          }}
        >
          列显示设置
        </Button>
      </div>
      <Select
        dropdownStyle={{ width: '160px', zIndex: 980 }} //viewer zIndex: 990
        open={open}
        value={columns}
        onChange={(value) => setColumns(value)}
        popupRender={(menuNode) => {
          return (
            <div>
              <h4
                style={{
                  margin: 0,
                  borderBottom: 'solid 1px #EBEDF0',
                  textAlign: 'center',
                  lineHeight: '32px'
                }}
              >
                列显示设置
              </h4>
              {menuNode}
              <div
                style={{ borderTop: 'solid 1px #EBEDF0', textAlign: 'center' }}
              >
                <Button type="link" onClick={handleCancel}>
                  取消
                </Button>
                <Button type="link" onClick={handleOK}>
                  确定
                </Button>
              </div>
            </div>
          )
        }}
        mode="multiple"
      >
        {getBaseColumnsData(
          () => {
            /* noop */
          },
          () => {
            /* noop */
          }
        ).map((column) => {
          // 为特殊的title提供纯文本显示
          let displayTitle = column.title
          if (typeof column.title === 'object' && column.title.props) {
            // 如果title是React组件（如ColumnHeaderWithTag），提取纯文本
            displayTitle = column.title.props.title || column.dataIndex
          }

          return (
            <Option key={column.dataIndex} value={column.dataIndex}>
              {displayTitle}
            </Option>
          )
        })}
      </Select>
    </div>
  )
}

export default ColumnsSetting
